import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TeamsService {
  teamsChanged = new Subject<string[]>();

  constructor(private localStorageService: LocalStorageService) {
  }


  get teams(): string[] {
    return this.localStorageService.retrieve('teams') ?? [];
  }

  set teams(teams: string[]) {
    this.localStorageService.store('teams', teams);
    this.teamsChanged.next(teams);
  }
}
